import { useMemo, useState } from 'react';
import { FIGMA_SCREEN_ASSETS } from '@/config/figmaScreens';

type ScreenSetId = 'brandKit' | 'dsFoundations' | 'operatorHome' | 'noviceHome' | 'operatorDeviceFlow';

type ScreenSet = {
  id: ScreenSetId;
  title: string;
  images: readonly string[];
};

const SCREEN_SETS: ScreenSet[] = [
  { id: 'brandKit', title: 'Brand kit', images: [FIGMA_SCREEN_ASSETS.brandKit] },
  { id: 'dsFoundations', title: 'DS foundations', images: [FIGMA_SCREEN_ASSETS.dsFoundations] },
  { id: 'operatorHome', title: 'Operator home', images: FIGMA_SCREEN_ASSETS.operatorHome },
  { id: 'noviceHome', title: 'Novice home', images: FIGMA_SCREEN_ASSETS.noviceHome },
  { id: 'operatorDeviceFlow', title: 'Operator device flow', images: FIGMA_SCREEN_ASSETS.operatorDeviceFlow },
];

export default function FigmaScreensPage() {
  const [activeId, setActiveId] = useState<ScreenSetId>('operatorHome');

  const active = useMemo(
    () => SCREEN_SETS.find((s) => s.id === activeId) ?? SCREEN_SETS[0],
    [activeId]
  );

  return (
    <div className="figma-screens">
      <header className="figma-screens__header">
        <h1 className="figma-screens__title">Figma baseline screens</h1>
        <p className="figma-screens__subtitle">
          Exports under <code>public/figma-screens</code>, used for parity checks.
        </p>
      </header>

      <nav className="figma-screens__nav" aria-label="Figma screen sets">
        {SCREEN_SETS.map((set) => {
          const isActive = set.id === activeId;
          return (
            <button
              key={set.id}
              type="button"
              className={`button button-secondary button-sm figma-screens__tab${isActive ? ' figma-screens__tab--active' : ''}`}
              onClick={() => setActiveId(set.id)}
            >
              {set.title}
            </button>
          );
        })}
      </nav>

      <section className="figma-screens__content" aria-label={active.title}>
        {active.images.map((src, idx) => (
          <figure key={src} className="figma-screens__figure">
            <img className="figma-screens__img" src={src} alt={`${active.title} ${idx + 1}`} loading="lazy" />
            <figcaption className="figma-screens__caption">{src}</figcaption>
          </figure>
        ))}
      </section>
    </div>
  );
}

